package com.xtream.data_kmp.dto


enum class StreamType{
  ICON,POSTER,BACKDROP,EXTRA_PORTRAIT,EXTRA_LANDSCAPE
}


interface BaseStream {

  abstract val added: String
  abstract val categoryId: Int?

  abstract  val customSid: String?
  abstract val directSource: String?

  abstract val isAdult: Int
  abstract val name: String?
  abstract val num: Int?
  abstract val streamIcon: String?
  abstract val streamId: Int

  @Deprecated("streamType is deprecated", ReplaceWith("type"))
  abstract val streamType: String

  abstract val type:StreamType

}


